module.exports = __webpack_public_path__ + "static/3-1200-a1b331bc2131585a6893421f921e01c0.png";